import src from "IMAGE";
export default { src, width: 1669, height: 1221, blurWidth: 0, blurHeight: 0};
